import { render, staticRenderFns } from "./data13.vue?vue&type=template&id=afe81f24&scoped=true"
import script from "./data13.vue?vue&type=script&lang=js"
export * from "./data13.vue?vue&type=script&lang=js"
import style1 from "./data13.vue?vue&type=style&index=1&id=afe81f24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe81f24",
  null
  
)

export default component.exports